import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Home, Refrigerator, CalendarDays, ShoppingCart } from "lucide-react";

const navItems = [
  { key: "home", path: "/", icon: Home },
  { key: "fridge", path: "/fridge", icon: Refrigerator },
  { key: "planner", path: "/planner", icon: CalendarDays },
  { key: "grocery", path: "/grocery", icon: ShoppingCart },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  if (["/login", "/onboarding"].includes(location.pathname) || location.pathname.startsWith("/recipe/")) {
    return null;
  }

  return (
    <div className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[9999] w-[calc(100%-40px)] max-w-[420px]">
      <nav
        data-testid="bottom-navigation"
        className="bg-white/95 backdrop-blur-xl rounded-full shadow-[0_8px_32px_rgba(0,0,0,0.12)] border border-black/5 px-3 py-2 flex justify-around items-center"
      >
        {navItems.map(({ key, path, icon: Icon }) => {
          const isActive = location.pathname === path;
          return (
            <button
              key={key}
              data-testid={`nav-${key}`}
              aria-label={t(key)}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center gap-0.5 py-1.5 px-4 rounded-full transition-all ${
                isActive
                  ? "bg-[#7B9E7F] text-white shadow-sm"
                  : "text-[#8B9D83] hover:text-[#5C7A5E]"
              }`}
            >
              <Icon className={`w-5 h-5 transition-transform ${isActive ? "scale-110" : ""}`} strokeWidth={isActive ? 2 : 1.5} />
              <span className="font-body text-[10px] font-bold">{t(key)}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
